/**
 * KOVIX-4084 — phân trang các danh sách mà API trả MẢNG (không con trỏ) — vd danh mục Mua hàng: tải một lần đến `limit`
 * rồi phân trang ở trình duyệt, chọn số dòng/trang như DS sản phẩm (KOVIX-3080). Đạt `limit` → báo người dùng thu hẹp lọc.
 */
import { useState } from 'react';

export const LIST_PAGE_SIZES = [20, 30, 40, 50] as const;
export const DEFAULT_LIST_PAGE_SIZE = 20;
/** Trần `limit` của GET /supply/purchase-orders (máy chủ chặn 1..500). */
export const PURCHASE_ORDER_LOAD_LIMIT = 500;

/** Đọc số dòng/trang từ URL: chỉ nhận giá trị trong danh sách và khác mặc định; còn lại → undefined (URL gọn). */
export function listPageSize(v: unknown): number | undefined {
  const n = typeof v === 'number' ? v : typeof v === 'string' && /^\d+$/.test(v) ? Number(v) : Number.NaN;
  return n !== DEFAULT_LIST_PAGE_SIZE && (LIST_PAGE_SIZES as readonly number[]).includes(n) ? n : undefined;
}

/** Câu báo khi số bản ghi đã tải chạm trần `limit` (bản ghi cũ hơn không có trong bảng); chưa chạm → null. */
export function listLoadCapNotice(count: number, limit: number, noun: string): string | null {
  return count >= limit
    ? `Đang hiển thị ${limit.toLocaleString('vi-VN')} ${noun} mới nhất (giới hạn tải) — dùng bộ lọc để xem bản ghi cũ hơn.`
    : null;
}

/** Cấu hình phân trang trình duyệt cho `DataTable` (số dòng/trang giữ trong màn, không ghi URL). */
export function useListPageSize(initial: number = DEFAULT_LIST_PAGE_SIZE) {
  const [pageSize, setPageSize] = useState(initial);
  return { pageSize, pageSizeOptions: LIST_PAGE_SIZES, onPageSizeChange: setPageSize };
}
